import {createActions} from 'redux-actions';

const actions = createActions('RECENT_LOADED');

export default actions;



// WEBPACK FOOTER //
// ./src/profile/recent.actions.js